import React from "react";
import { Tag, Badge } from "antd";
import {
  CheckCircleOutlined,
  StopOutlined,
  WarningOutlined,
  InfoCircleOutlined,
} from "@ant-design/icons";

// --- Individual renderers ---

const StoppedOutcome = {
  matches: (job) => job.status === "STOPPED" || job.stopReason,
  render: (job) => (
    <Tag icon={<StopOutlined />} color="orange">
      Stopped{job.stopReason ? `: ${job.stopReason}` : ""}
    </Tag>
  ),
};

const AllSuccessOutcome = {
  matches: (job) =>
    job.status === "COMPLETED" && (job.documentsFailed === 0 || job.documentsFailed == null),
  render: (job) => (
    <Tag icon={<CheckCircleOutlined />} color="green">
      {job.documentsProcessed ?? 0} ingested
    </Tag>
  ),
};

const CategorizedFailureOutcome = {
  matches: (job) => job.status === "COMPLETED" && job.documentsFailed > 0,
  render: (job) => (
    <span>
      <Tag icon={<CheckCircleOutlined />} color="green">
        {job.documentsProcessed ?? 0} ingested
      </Tag>
      <Tag icon={<WarningOutlined />} color="red">
        {job.documentsFailed} failed
      </Tag>
    </span>
  ),
};

const DefaultOutcome = {
  matches: () => true,
  render: (job) => (
    <Tag icon={<InfoCircleOutlined />} color="default">
      {job.status || "Unknown"}
    </Tag>
  ),
};

// --- Strategy list (order matters, first match wins) ---

const renderers = [StoppedOutcome, AllSuccessOutcome, CategorizedFailureOutcome, DefaultOutcome];

/**
 * Render the outcome for a crawl job.
 * @param {Object} job - crawl job object
 * @returns {JSX.Element}
 */
export function renderOutcome(job) {
  if (!job) return <Tag color="default">--</Tag>;
  for (const r of renderers) {
    if (r.matches(job)) return r.render(job);
  }
  return <Tag color="default">--</Tag>;
}

export default renderOutcome;
